module.exports = __webpack_public_path__ + "img/prizeRedEnvelopes.065f0b61.png";